import theme from '@styles/theme';
const styles = {
  modalHeading: {
    padding: '0 16px',
    maxHeight: '925px'
  },
  modalContainer: (isSuccess: boolean) => ({
    display: isSuccess ? 'flex' : 'block',
    justifyContent: isSuccess ? 'center' : 'flex-start',
    fontFamily: `${theme.fonts.uniformMedium} !important`
  }),
  modalHeadingText: {
    fontWeight: `${theme.fontWeights.medium} !important`,
    lineHeight: '24px !important',
    letterSpacing: '1.2px !important',
    fontFamily: `${theme.fonts.uniformMedium} !important`
  },
  modalContent: {
    padding: ['24px 16px', '24px 16px', '24px 40px'],
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  scrollableContent: {
    flex: 1,
    overflowY: 'auto',
    paddingRight: '8px',
    scrollbarWidth: '42px',
    scrollbarColor: `${theme.rawColors.darkGrey700} ${theme.rawColors.lightGrey300}`,
    '&::-webkit-scrollbar': {
      width: '2px',
      background: theme.rawColors.neutralWhite,
      borderRadius: '2px'
    },
    '&::-webkit-scrollbar-track': {
      background: theme.rawColors.lightGrey500
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '2px',
      background: theme.rawColors.darkGrey700
    },
    [`@media (max-width: ${theme.breakpoints[2]})`]: {
      scrollbarWidth: 'thin',
      '&::-webkit-scrollbar': {
        width: '0px'
      }
    }
  },
  infoContainer: {
    padding: '16px',
    background: theme.rawColors.lightGreyBgProduct
  },
  infoContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '12px',
    mb: '8px',
    pt: '4px'
  },
  infoText: {
    fontSize: '14px',
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform
  },
  smallInfoContainer: {
    marginTop: '16px'
  },
  smallInfoText: {
    fontSize: '12px',
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform
  },
  section: {
    paddingLeft: '4px',
    marginTop: '40px',
    '&:last-of-type': {
      marginBottom: '8px'
    }
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: '400',
    color: 'darkGrey700',
    margin: '0 0 24px 0'
  },
  questionTextarea: {
    height: '74px',
    padding: '14px',
    maxHeight: '144px'
  },
  formInfo: {
    fontSize: '12px',
    color: theme.rawColors.darkGrey700,
    fontFamily: theme.fonts.uniform,
    marginTop: '-25px'
  },
  sectionTitleContainer: {
    marginBottom: '24px'
  },
  fullNameInput: {
    marginBottom: '16px'
  },
  emailInput: {
    marginBottom: '12px'
  },
  phoneContainer: {
    display: 'flex',
    gap: '16px',
    marginBottom: '12px'
  },
  phoneCountryCodeSelect: {
    width: '120px',
    marginBottom: '0px'
  },
  phoneNumberInput: {
    flex: 1,
    marginBottom: '0px'
  },
  footer: {
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: ['12px', '12px', '40px'],
    marginTop: 'auto',
    paddingTop: '24px',
    borderTop: '1px solid',
    borderTopColor: 'lightGrey300',
    flexShrink: 0
  },
  consentContainer: {
    flex: 1,
    maxWidth: '550px'
  },
  consentText: {
    fontSize: '14px',
    color: 'darkGrey700',
    lineHeight: '140%'
  },
  regulationsLink: {
    textDecoration: 'underline',
    color: 'darkGrey700 !important'
  },
  submitButton: {
    minWidth: '200px',
    height: '60px',
    fontFamily: theme.fonts.uniformMedium,
    fontSize: '16px',
    fontWeight: theme.fontWeights.medium,
    lineHeight: '140%',
    letterSpacing: '1.6px',
    flex: 'auto',
    width: ['100%', '100%', 'auto']
  },
  // Success screen styles
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '40px 20px',
    flex: 1
  },
  successFooter: {
    borderTop: '1px solid',
    borderTopColor: 'lightGrey300',
    paddingTop: '24px',
    paddingBottom: '0',
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  },
  successIconContainer: {
    padding: '64px',
    marginBottom: '24px'
  },
  successIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    border: '2px solid',
    borderColor: 'darkGrey700'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  },
  successTitle: {
    fontSize: '20px',
    fontStyle: 'normal',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    letterSpacing: '1px',
    lineHeight: '140%',
    color: 'darkGrey700',
    marginBottom: '8px',
    textAlign: 'center'
  },
  successMessage: {
    fontSize: '16px',
    fontFamily: theme.fonts.uniform,
    fontWeight: theme.fontWeights.normal,
    lineHeight: '140%',
    color: 'darkGrey700'
  },
  closeButton: {
    width: '100%',
    fontFamily: theme.fonts.uniform,
    height: '58px',
    fontWeight: theme.fontWeights.medium,
    lineHeight: '140%',
    fontSize: '16px'
  },
  checkboxContainer: {
    gap: '8px'
  }
};
export default styles;